import { default as indexVETclcTILSMeta } from "/vercel/path0/apps/mrhs/psychiatry/pages/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/apps/mrhs/psychiatry/pages/index.vue")
  }
]